import { createRequest } from "helpers/tools";

export const deleteTracker = async (id) => {
    return await createRequest({
        suffix: `trackers/${id}`,
        method: "delete",
        handleError: false,
    });
};
